import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqItems } from "@/config/checklisteConfig";

const FAQClean = () => {
  return (
    <section className="py-20 sm:py-28 lg:py-32 relative">
      {/* Dezenter Gradient Overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse at bottom, hsl(var(--accent) / 0.07), transparent 70%)"
        }}
      />
      
      <div className="container max-w-4xl mx-auto px-6 sm:px-8 relative z-10">
        
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Häufig gestellte <span className="text-accent">Fragen</span>
          </h2>
          <p className="text-xl sm:text-2xl text-muted-foreground">
            Alles, was Sie über die Cyber-Checkliste wissen müssen
          </p>
        </div>
        
        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item, idx) => (
            <AccordionItem 
              key={idx} 
              value={`item-${idx}`}
              className="border border-white/10 rounded-lg px-8 backdrop-blur-sm data-[state=open]:border-accent/50 transition-all"
            >
              <AccordionTrigger className="text-lg sm:text-xl font-semibold hover:text-accent hover:no-underline py-5">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-base sm:text-lg text-muted-foreground pb-5 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQClean;
